import { Table, Column, Cell, ColumnHeaderCell } from 'callahan-react'
import React from 'react'

import { formatDate } from '../../utils/date-utils.js'

class UserTable extends React.Component {
  renderCell = (index, prop, modifier) => {
    const { displayData } = this.props
    const data = displayData[index]
    return (
      <Cell key={data.id} className="ui-cell">
        <h5 className="cell-header">
          {typeof modifier !== 'undefined' ? modifier(data[prop]) : data[prop]}
        </h5>
      </Cell>
    )
  }

  highlightAdmin = type => {
    if (type === 'ADMIN') {
      return <span className="admin-highlight">ADMIN</span>
    }
    return type
  }

  renderIdCell = rowIndex => this.renderCell(rowIndex, 'id')

  renderNameCell = rowIndex => this.renderCell(rowIndex, 'name')

  renderStatusCell = rowIndex => this.renderCell(rowIndex, 'status')

  renderTypeCell = rowIndex => this.renderCell(rowIndex, 'userType', this.highlightAdmin)

  renderCreatedDateCell = rowIndex => this.renderCell(rowIndex, 'createdDate', formatDate)

  renderUpdatedDateCell = rowIndex => this.renderCell(rowIndex, 'updatedDate', formatDate)

  render() {
    const { displayData } = this.props
    const cols = [
      {
        title: 'User ID',
        key: 'id',
        render: this.renderIdCell
      },
      {
        title: 'Name',
        key: 'name',
        render: this.renderNameCell
      },
      {
        title: 'Status',
        key: 'status',
        render: this.renderStatusCell
      },
      {
        title: 'User Type',
        key: 'type',
        render: this.renderTypeCell
      },
      {
        title: 'Created Date',
        key: 'created',
        render: this.renderCreatedDateCell
      },
      {
        title: 'Updated Date',
        key: 'updated',
        render: this.renderUpdatedDateCell
      }
    ].map(col => {
      return (
        <Column
          header={
            <ColumnHeaderCell>
              <h4>{col.title}</h4>
            </ColumnHeaderCell>
          }
          key={col.key}
          renderCell={col.render}
          grow={true}
        />
      )
    })

    return (
      <div>
        <div className="table-holder">
          <Table displayData={displayData} grow={true}>
            {cols}
          </Table>
        </div>
      </div>
    )
  }
}
export default UserTable



// WEBPACK FOOTER //
// ./src/pages/UserInfo/UserTable.js